"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canAccessChannelByPricingPlan = exports.canSubscribeToChannelByPricingPlan = exports.canSubscribeToChannel = exports.canAccessChannelWithSubscription = void 0;
var pricing_1 = require("../../common/ui-selectors/channel/pricing");
function canAccessChannelWithSubscription(channel) {
    return (0, pricing_1.isSubscriptionEnabled)(channel) && (0, pricing_1.isSubscribedTo)(channel);
}
exports.canAccessChannelWithSubscription = canAccessChannelWithSubscription;
function canSubscribeToChannel(channel) {
    return (0, pricing_1.isSubscriptionEnabled)(channel) && !(0, pricing_1.isSubscribedTo)(channel);
}
exports.canSubscribeToChannel = canSubscribeToChannel;
function canSubscribeToChannelByPricingPlan(channel) {
    return ((0, pricing_1.isPricingPlanEnabled)(channel) && !(0, pricing_1.hasAccessToChannelByPricingPlan)(channel));
}
exports.canSubscribeToChannelByPricingPlan = canSubscribeToChannelByPricingPlan;
function canAccessChannelByPricingPlan(channel) {
    return ((0, pricing_1.isPricingPlanEnabled)(channel) && (0, pricing_1.hasAccessToChannelByPricingPlan)(channel));
}
exports.canAccessChannelByPricingPlan = canAccessChannelByPricingPlan;
//# sourceMappingURL=channel-access.js.map